var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "memorandum_create_block" }, [
    _c(
      "div",
      { staticClass: "list_mem_create" },
      [
        _c("div", { staticClass: "panel" }, [
          _c(
            "div",
            { staticClass: "panel-hdr bg-primary-500 bg-success-gradient" },
            [
              _c("h2", [
                _vm._v(
                  "\n                    POS Sync: " +
                    _vm._s(this.provider.human_name) +
                    "\n                "
                ),
              ]),
              _vm._v(" "),
              !_vm.is_excel
                ? _c("div", { staticClass: "panel-toolbar" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-sm btn-success shadow-0 waves-effect waves-themed",
                        on: { click: _vm.show_settings },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.__t("BASE")) +
                            " "
                        ),
                        _c("i", { staticClass: "fal fa-cog" }),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "panel-container show" }, [
            _c(
              "div",
              { staticClass: "panel-content" },
              [
                _c(
                  "b-overlay",
                  { attrs: { show: _vm.is_load, rounded: "sm" } },
                  [
                    _vm.is_load_complete
                      ? _c(
                          "div",
                          { staticClass: "work_area" },
                          [
                            !_vm.pos_item.is_init
                              ? _c("pos_empty", {
                                  attrs: { pos_item: _vm.pos_item },
                                  on: { excel_ready: _vm.go_next_step_excel },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.is_load_complete && _vm.pos_item.is_init
                              ? _c("pos_sync")
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "panel-content py-2 rounded-bottom border-faded border-left-0 border-right-0 border-bottom-0 text-muted d-flex",
              },
              [
                _c(
                  "span",
                  { staticClass: "badge badge-info fw-400 mr-2 pt-1" },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(this.provider.human_name) +
                        " :  " +
                        _vm._s(_vm.provider.id) +
                        "\n                    "
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("pos_settings_modal"),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }